import { OrangeIcon } from '../DetailComponents/utils';

export const alumbradoConfig = {
  id: 'alumbrado',
  label: 'Alumbrado Público',
  regex: /alumbrado|luminaria|alumbrad|lumbrado|farol|poste\s+luz/i,
  autoHeatmap: false,
  icon: OrangeIcon,
  jsonFields: [
    { key: 'tipo_luminaria', label: 'Tipo Luminaria' },
    { key: 'altura_poste', label: 'Altura Poste (m)' },
    { key: 'estado', label: 'Estado' },
    { key: 'potencia_watts', label: 'Potencia (W)' },
    { key: 'funciona', label: 'Funciona', type: 'bool' },
    { key: 'cable_expuesto', label: 'Cable Expuesto', type: 'bool' },
    { key: 'soporte_danado', label: 'Soporte Dañado', type: 'bool' },
  ],
  renderExtraInfo: () => null,
  subFilters: [],
  calculatePriority: () => 'Baja',
  calculateCompany: () => 'N/A',
  summaryConfig: {
    showCompanyKPI: false,
    showPriorityKPI: false,
    mainChart: 'streets'
  },
  hasPriority: false,
  hasCompany: false
};
